module.exports = __webpack_public_path__ + "static/media/img__rank-battle.229a10d0.png";